// extracted by mini-css-extract-plugin
module.exports = {"progress":"Progress_progress__xyO5D","progress--bigger":"Progress_progress--bigger__q6Eaf","bar":"Progress_bar__l35ZL","bar--achieved":"Progress_bar--achieved__3_Qat"};